import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
  Badge, CustomerIcon, sizeVars, Tooltip,
} from '@routific/hive/v5';

export const FromCustomerMark: React.FC = () => {
  const { t } = useTranslation('components');
  const label = t('linkedCustomer.filledFromCustomer');

  return (
    <Tooltip title={label} placement="top">
      <Badge size="sm" role="img" aria-label={label} data-testid="from-customer-mark">
        <CustomerIcon size="sm" />
      </Badge>
    </Tooltip>
  );
};

const Leading = styled.span`
  display: flex;
  align-items: flex-start;
  gap: ${sizeVars.space[50]};
  max-width: 100%;
`;

const FirstLine = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  height: ${sizeVars.typography.lineHeights.base};
`;

export const withFromCustomer = (value: React.ReactNode, fromCustomer: boolean) => (fromCustomer ? (
  <Leading>
    <FirstLine><FromCustomerMark /></FirstLine>
    {value}
  </Leading>
) : value);
